module.exports = __webpack_public_path__ + "img/1_1-orto-1.4785377e.png";